/** Selector de hora compartido (5 min, 00:00–23:55). Acepta cualquier valor HH:MM aunque no esté en la lista. */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatTime12 } from '@/utils/bookingFormat';

const OPTIONS = (() => {
  const out = [];
  for (let m = 0; m < 24 * 60; m += 5) out.push(`${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`);
  return out;
})();

export const TimeSelect = ({ value, onChange, testId, className = '' }) => {
  const opts = value && !OPTIONS.includes(value) ? [...OPTIONS, value].sort() : OPTIONS;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`bg-background border-border h-9 w-[110px] text-xs ${className}`} data-testid={testId}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-card border-border max-h-64">
        {opts.map((t) => <SelectItem key={t} value={t}>{formatTime12(t)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
